import { render } from "./B2bFilterButtonTaxes.vue?vue&type=template&id=e3068c56&scoped=true&lang=pug"
import script from "./B2bFilterButtonTaxes.vue?vue&type=script&lang=js"
export * from "./B2bFilterButtonTaxes.vue?vue&type=script&lang=js"

import "./B2bFilterButtonTaxes.vue?vue&type=style&index=0&id=e3068c56&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3068c56"]])

export default __exports__